import { useEffect, useState } from 'react';

/** Google is the only way in. There is no password field to phish, no reset flow
 *  to get wrong, and nothing for a household to write on a sticky note. */

const MESSAGES: Record<string, string> = {
  not_invited:
    'That Google account is not part of this household yet. Ask whoever set up Hestia to add your address.',
  cancelled: 'Sign-in was cancelled.',
  expired: 'That took too long — try again.',
  bad_state: 'Something went wrong on the way back from Google. Try again.',
  bad_callback: 'Something went wrong on the way back from Google. Try again.',
  email_unverified: 'That Google account has no verified email address.',
  no_email: 'Google did not share an email address for that account.',
  bad_id_token: 'Could not verify the response from Google. Try again.',
  bad_nonce: 'Could not verify the response from Google. Try again.',
  token_exchange_failed: 'Google would not complete the sign-in. Try again.',
  no_id_token: 'Google would not complete the sign-in. Try again.',
  google_error: 'Google could not sign you in. Try again in a moment.',
};

function GoogleMark() {
  // Google's own mark, which their branding terms require on this button.
  return (
    <svg width="19" height="19" viewBox="0 0 48 48" style={{ stroke: 'none' }} aria-hidden="true">
      <path fill="#4285F4" d="M45.1 24.5c0-1.6-.1-3.2-.4-4.7H24v8.9h11.8a10 10 0 0 1-4.4 6.6v5.5h7.1c4.1-3.8 6.6-9.4 6.6-16.3z" />
      <path fill="#34A853" d="M24 46c5.9 0 10.9-2 14.5-5.2l-7.1-5.5c-2 1.3-4.5 2.1-7.4 2.1-5.7 0-10.5-3.8-12.2-9H4.5v5.7A22 22 0 0 0 24 46z" />
      <path fill="#FBBC05" d="M11.8 28.4a13.2 13.2 0 0 1 0-8.4v-5.7H4.5a22 22 0 0 0 0 19.8l7.3-5.7z" />
      <path fill="#EA4335" d="M24 10.8c3.2 0 6.1 1.1 8.4 3.3l6.3-6.3C34.9 4.2 29.9 2 24 2A22 22 0 0 0 4.5 14.3l7.3 5.7c1.7-5.2 6.5-9.2 12.2-9.2z" />
    </svg>
  );
}

export function Login() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('error');
    if (!code) return;
    setError(MESSAGES[code] ?? MESSAGES.google_error!);
    // Clear the query so a reload does not resurrect a stale error.
    window.history.replaceState(null, '', window.location.pathname);
  }, []);

  return (
    <div style={{ minHeight: '100%', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 360, display: 'flex', flexDirection: 'column',
                    gap: 22, background: 'rgba(255,255,255,.78)', backdropFilter: 'blur(26px)',
                    WebkitBackdropFilter: 'blur(26px)', borderRadius: 'var(--r-panel)',
                    padding: 32, boxShadow: 'var(--sh-panel)' }}>
        <div>
          <h1 className="dsp" style={{ fontSize: 30, margin: 0 }}>Hestia</h1>
          <p style={{ margin: '6px 0 0', color: 'var(--ink-2)', fontSize: 14 }}>The family list.</p>
        </div>

        {error && (
          <div style={{ fontSize: 13.5, lineHeight: 1.5, color: 'var(--amber-on)',
                        background: 'var(--amber-tint)', borderRadius: 'var(--r-inset)',
                        padding: '13px 15px' }} role="alert">
            {error}
          </div>
        )}

        <a className="pill" href="/api/auth/google"
           style={{ height: 52, fontSize: 15, fontWeight: 600, background: '#fff',
                    color: 'var(--ink)', border: '1.5px solid var(--line)', gap: 11 }}>
          <GoogleMark />Continue with Google
        </a>

        <p style={{ margin: 0, fontSize: 12.5, lineHeight: 1.5, color: 'var(--ink-3)' }}>
          Only accounts already added to this household can sign in.
        </p>
      </div>
    </div>
  );
}
